module.exports = __webpack_public_path__ + "static/media/shiba_inu.gamatron.5e90d9c0.jpeg";